export enum PermissionEnum {
  UserManagement = 200,
  SendScheduleCampaigns = 201,
  ViewReview = 203,
  FeatureReviewOrRespond = 204,
  ViewSurvey = 205,
  ManageCustomers = 601,
  ManageDatasyncConfiguration = 602,
  ProvisionAccounts = 603,
  UpdateFeatureFlags = 605,
  AdvancedFeatureFlagManagement = 606,
  ManageEnterpriseTextCommunicationSettings = 901,
  ManagePracticeTextCommunicationSettings = 902,
  CreateForm = 1000,
  DeleteForm = 1001,
  EditContentForm = 1003,
  ManageFormPacket = 1004
}
